import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const BannerContainer = styled.div`
  width: 100%;
  height: 90px;
  cursor: pointer;
  background-color: ${customPalette.accent.main};
  border-radius: 8px;
  display: grid;
  grid-template-columns: 40% 45% 15%;
  overflow: hidden;
  border: 3px solid ${customPalette.accent.main};
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 90px;
  display: block;
  object-fit: cover;
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  color: ${customPalette.accent.white};
`;

export const BannerTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  opacity: 0.8;
  margin-bottom: 2px;
`;

export const BannerSubtitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-word;
  hyphens: auto;

  @supports (-webkit-line-clamp: 2) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (max-width: 400px) {
    font-size: 16px;
  }

  @media (max-width: 350px) {
    font-size: 14px;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${customPalette.accent.white};

  svg {
    font-size: 24px;
  }
`;
